<template>
	<div class="new-certify-query-wrapper">
		<div class="pc-certify-query-main">
			<div class="query-main-con">
				<div class="certify-head-con">
					<div class="head-main-con">
						<div class="left-logo">
							<img src="~/assets/images/query/cflp-logo.png" alt="" />
							<span class="sp-text">全国统一联网查询</span>
						</div>
						<!-- <div class="top-btn">
							<router-link :to="{ name: 'xHome' }">
								<i class="wl-icon-fanhui2"></i>
								返回主站 
							</router-link>
						</div> -->
					</div>
				</div>

				<div class="certify-content-con">
					<div class="select-enter-li-con">
						<div class="select-enter-li" @click="enterQuery(2)">
							<div class="top-line"></div>
							<div class="li-center">
								<img class="img-icon" src="~/assets/images/query/icon2.png" alt="" />
								<div class="left-btn">
									<div class="p-select-title">成绩查询</div>
									<div class="query-btn" @click="enterQuery(2)">
										立即查询
										<i class="wl-icon-youjiantou"></i>
									</div>
								</div>
							</div>
						</div>
						<div class="select-enter-li" @click="enterQuery(3)">
							<div class="top-line"></div>
							<div class="li-center">
								<img class="img-icon" src="~/assets/images/query/icon1.png" alt="" />
								<div class="left-btn">
									<div class="p-select-title">证书查询</div>
									<div class="query-btn" @click="enterQuery(3)">
										立即查询
										<i class="wl-icon-youjiantou"></i>
									</div>
								</div>
							</div>
						</div>

						<!-- <div class="select-enter-li tea-enter-li" @click="enterQuery(3)">
							<div class="p-select-title">师资证书查询</div>
							<p class="p-text">
								仅限于查询参加
								<span class="sp-color">中国物流与采购联合会、北京中物联物流采购培训中心</span>
								相关培训后获得的师资证书；
							</p>
							<div class="query-btn" @click="enterQuery(3)">
								<i class="wl-icon-chaxun1"></i>
								查询
							</div>
						</div> -->
					</div>
					<div class="li-column">
						<div class="column-title">业务网站</div>
						<div class="list-con">
							<div class="li-con"><a href="https://bm.clpp.org.cn/" target="_blank">中物联职业能力等级证书综合服务平台</a></div>
							<div class="li-con"><a href="https://www.clppx.org.cn/" target="_blank">北京中物联1+X官网平台</a></div>
							<div class="li-con"><a href="http://resource.clppx.org.cn/" target="_blank">中物联课程与资源服务平台</a></div>
						</div>
					</div>
					<div class="li-column">
						<div class="column-title">友情链接</div>
						<div class="list-link">
							<div class="li-con"><a href="http://www.moe.gov.cn/" target="_blank">&nbsp;</a></div>
							<div class="li-con"><a href="http://www.civte.edu.cn/" target="_blank">&nbsp;</a></div>
							<div class="li-con"><a href="https://vslc.ncb.edu.cn/" target="_blank">&nbsp;</a></div>
							<div class="li-con"><a href="http://www.chinawuliu.com.cn/" target="_blank">&nbsp;</a></div>
						</div>
					</div>
				</div>
			</div>
			<div class="wl-index-footer-content">
				<div class="index-footer-con clearfix">
					<div class="fl company-footer-info">
						<div class="clearfix">
							<div class="company-footer-logo-con">
								<img src="~/assets/images/clpp-logo-white.png" alt class="ph-footer-logo-img" />
							</div>
						</div>
						<!-- <div class="btn-contacts-number clearfix"> -->
						<p class="p-footer-1">
							<i class="wl-icon-dingwei"></i>
							<span class="sp-info-label">地址：北京市丰台区丽泽路16号院2号楼铭丰大厦1106室</span>
							<i class="wl-icon-tubiao209"></i>
							<span class="sp-info-label">邮编：100079</span>
							<i class="wl-icon-tubiao209"></i>
							<span class="sp-info-label">邮箱： x@clpp.org.cn</span>
						</p>
						<!-- </div> -->
						<p class="p-footer-2">
							<span>Copyright 版权所有 ©</span>
							<span class="sp-info-label">北京中物联物流采购培训中心</span>
							<span>备案号：</span>
							<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19032250号-1</a>
						</p>
					</div>
					<div class="fr company-footer-code-con clearfix">
						<!-- <div class="fl f-code-img-con">
                            <img :src="footImage" alt class="f-code-img">
                            <p class="f-code-name">中物联教育培训</p>
                            </div>-->
						<div class="fr f-code-img-con f-code-img-con-1">
							<img src="~/assets/images/qrcode.png" alt class="f-code-img" />
							<p class="f-code-name">中物联教育培训公众号</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 移动端 -->
		<div class="ph-certify-query-main">
			<div class="certify-head-con">
				<div class="left-logo">
					<img src="~/assets/images/query/cflp-logo.png" alt="" />
					<span class="sp-text">全国统一联网查询</span>
				</div>
				<!-- <div class="top-btn">
					<router-link :to="{ name: 'xHome' }">
						<i class="wl-icon-fanhui2"></i>
						返回主站
					</router-link>
				</div> -->
			</div>
			<div class="ph-certify-con-main">
				<div class="ph-search-btns-con">
					<div class="ph-search-btn" @click="enterQuery(2)">
						<div class="top-line"></div>
						<img class="img-icon" src="~/assets/images/query/icon2.png" alt="" />
						<p class="p-search-head">成绩查询</p>

						<div class="now-searach-btn" @click="enterQuery(1)">
							<i class="wl-icon-chaxun1"></i>
							查询
						</div>
					</div>
					<div class="ph-search-btn" @click="enterQuery(3)">
						<div class="top-line"></div>
						<img class="img-icon" src="~/assets/images/query/icon1.png" alt="" />
						<p class="p-search-head">证书查询</p>

						<div class="now-searach-btn" @click="enterQuery(3)">
							<i class="wl-icon-chaxun1"></i>
							查询
						</div>
					</div>
					<!-- <div class="ph-search-btn" @click="enterQuery(3)">
						<p class="p-search-head">师资证书查询</p>
						<p class="ph-p-text">
							仅限于查询参加
							<span class="sp-color">中国物流与采购联合会、北京中物联物流采购培训中心</span>
							相关培训后获得的师资证书；
						</p>
						<div class="now-searach-btn" @click="enterQuery(3)">
							<i class="wl-icon-chaxun1"></i>
							查询
						</div>
					</div> -->
					<div class="li-column">
						<div class="column-title">业务网站</div>
						<div class="list-con">
							<div class="li-con"><a href="https://bm.clpp.org.cn/" target="_blank">中物联职业能力等级证书综合服务平台</a></div>
							<div class="li-con"><a href="https://www.clppx.org.cn/" target="_blank">北京中物联1+X官网平台</a></div>
							<div class="li-con"><a href="http://resource.clppx.org.cn/" target="_blank">中物联课程与资源服务平台</a></div>
						</div>
					</div>
					<div class="li-column">
						<div class="column-title">友情链接</div>
						<div class="list-link">
							<div class="li-con"><a href="http://www.moe.gov.cn/" target="_blank">&nbsp;</a></div>
							<div class="li-con"><a href="http://www.civte.edu.cn/" target="_blank">&nbsp;</a></div>
							<div class="li-con"><a href="https://vslc.ncb.edu.cn/" target="_blank">&nbsp;</a></div>
							<div class="li-con"><a href="http://www.chinawuliu.com.cn/" target="_blank">&nbsp;</a></div>
						</div>
					</div>
				</div>
			</div>
			<div class="ph-index-footer-content">
				<div class="index-footer-con clearfix">
					<div class="company-footer-info">
						<!-- <div class="company-footer-logo-con">
                            <img :src="footerLogo" alt>
                            </div>-->
						<p class="p-footer-1">
							<i class="wl-icon-dingwei"></i>
							<span class="sp-info-label">地址：北京市丰台区丽泽路16号院2号楼铭丰大厦1106室</span>
						</p>
						<p class="p-footer-2">
							<i class="wl-icon-tubiao209"></i>
							<span class="sp-info-label">邮编：100079</span>
						</p>
						<p class="p-footer-2">
							<i class="wl-icon-tubiao209"></i>
							<span class="sp-info-label">邮箱：x@clpp.org.cn</span>
						</p>
					</div>
					<div class="company-footer-code-con clearfix">
						<!-- <div class="f-code-img-con fl">
                        <img :src="footerLogo" alt class="f-code-img" />
                    </div> -->
						<div class="f-code-img-con">
							<img src="~/assets/images/qrcode.png" alt class="f-code-img" />
							<p class>中物联教育培训公众号</p>
						</div>
					</div>
					<p class="p-footer-3">
						<span>Copyright 版权所有 ©</span>
						<span class="sp-info-label">北京中物联物流采购培训中心</span>
					</p>
					<p class="p-footer-4">
						<span>备案号：</span>
						<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19032250号-1</a>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			logo: require('assets/images/ce-qeury-logo.png'),
		};
	},
	mounted() {
		if(!document.getElementById('embed-lite-bubble-image')){
			new EmbedLiteSDK({
				appId: '709d8b92-5683-48ad-bc05-2efdc732705b',
				code: 'embed3p9TC2DqOWFaVfAbsfQI',
				imageUrl: 'https://file.clpp.org.cn/ykt/ori/seiwar2qh5tm31taautdra/w7Ytp6dAfRtwGsZA.png'
			});
		}
		

		// if (window.EmbedLiteSDK) {
		// 	return;
		// }
		// // 创建第一个 script 标签
		// const script1 = document.createElement('script');
		// script1.src = '/public/embedLiteSDK.js';
		// script1.onload = () => {
		// 	// 第一个脚本加载完成后，创建并插入第二个脚本
		// 	const script2 = document.createElement('script');
		// 	script2.textContent = `
        //         new EmbedLiteSDK({
		// 			appId: '709d8b92-5683-48ad-bc05-2efdc732705b',
		// 			code: 'embed3p9TC2DqOWFaVfAbsfQI',
		// 			imageUrl: 'https://file.clpp.org.cn/ykt/ori/seiwar2qh5tm31taautdra/w7Ytp6dAfRtwGsZA.png'
        //         });
        //     `;
		// 	document.body.appendChild(script2);
		// };
		// document.body.appendChild(script1);	
	},
	methods: {
		enterQuery(type) {
			if (type != 3) {
				this.$router.push({
					name: 'certifyQueryNew',
					params: {
						type: type,
					},
				});
			} else {
				this.$router.push({
					name: 'teachersQueryNew',
					params: {
						type: type,
					},
				});
			}
		},
	},
};
</script>

<style lang="scss"></style>
